import React, { useState } from 'react'
import { motion } from 'framer-motion'
import Section2Image from '../../assets/images/Section2.png'
import Section2PopUp1 from '../../assets/image/Frame 1535.svg'
import Section2PopUp2 from '../../assets/image/Content 1.svg'
import Section2PopUp3 from '../../assets/image/Modal (2) 1.svg'
import '../../index.css'
import LandingPageModal from 'components/Modal'
import { Link } from 'react-router'

const fadeInUpVariant = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.9 } },
}

const Section2 = () => {
  const [, setIsMobileMenuOpen] = useState(false)
  const [modalData, setModalData] = useState({ isOpen: false, type: '' })

  const handleModalOpen = (type) => {
    setModalData({ isOpen: true, type })
    setIsMobileMenuOpen(false)
  }

  const handleModalClose = () => {
    setModalData({ isOpen: false, type: '' })
  }

  return (
    <motion.section
      className="Section2"
      variants={fadeInUpVariant}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }} // triggers when 20% visible
    >
      <div className="Section2-container">
        {/* Left content */}
        <motion.div variants={fadeInUpVariant} transition={{ delay: 0.4 }}>
          <h2 className="font-roboto font-bold text-[40px] leading-[120%] tracking-normal">
            Become a Student
          </h2>

          <p className="font-roboto font-normal text-[18px] leading-[150%] tracking-normal text-justify">
            At APOLO P2P, we connect you with highly qualified tutors who are experts in all aspects
            of the blockchain ecosystem. Our tutors undergo a rigorous vetting process to ensure you
            receive top-notch education.
          </p>

          <h4 className="font-roboto font-bold text-[20px] leading-[140%] tracking-normal">
            Vetted Experts
          </h4>
          <p className="font-roboto font-normal text-[18px] leading-[150%] tracking-normal text-justify">
            Learn from industry veterans with proven experience in their fields. Our tutors go
            through rigorous tests and KYC verifications to guarantee genuine and qualified
            professional tutors.
          </p>

          <h4 className="font-roboto font-bold text-[20px] leading-[140%] tracking-normal">
            Diverse Topics
          </h4>
          <p className="font-roboto font-normal text-[18px] leading-[150%] tracking-normal text-justify">
            Explore your curiosity within the basics of the blockchain ecosystem: blockchain
            development, cryptocurrency, NFT, trading, DAO, smart contracts and decentralized
            finance.
          </p>

          <h4 className="font-roboto font-bold text-[20px] leading-[140%] tracking-normal">
            Flexible Scheduling
          </h4>
          <p className="font-roboto font-normal text-[18px] leading-[150%] tracking-normal text-justify">
            Book at your own convenience. With our global network of professional tutors, you can
            learn anytime and anywhere.
          </p>
          <Link to="/student/register">
            <button className="font-inter font-semibold text-[18px] leading-[28px] tracking-normal">
              Become a Student
            </button>
          </Link>
        </motion.div>

        {/* Right image container */}
        <motion.div
          className="relative overflow-visible flex justify-center"
          variants={fadeInUpVariant}
          transition={{ delay: 0.8 }}
        >
          {/* Main image */}
          <img src={Section2Image} alt="Section2-Image" className="w-[90%] max-w-[560px] h-auto" />

          {/* PopUp1 */}
          <motion.img
            src={Section2PopUp1}
            alt="PopUp1-Image"
            className="absolute top-6 left-6 w-20 sm:top-12 sm:left-20 sm:w-28"
            initial={{ opacity: 0, scale: 0.8, y: -30 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.5 }}
          />

          {/* PopUp2 */}
          <motion.img
            src={Section2PopUp2}
            alt="PopUp2-Image"
            className="absolute top-[160px] right-[-40px] w-[200px] sm:top-[310px] sm:right-[-80px] sm:w-[300px] sm:h-[68px]"
            initial={{ opacity: 0, scale: 0.9, x: 60 }}
            whileInView={{ opacity: 1, scale: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.7 }}
          />

          {/* PopUp3 */}
          <motion.img
            src={Section2PopUp3}
            alt="PopUp3-Image"
            className="absolute top-[240px] left-2 w-20 sm:top-[360px] sm:left-8 sm:w-28"
            initial={{ opacity: 0, scale: 0.8, y: 30 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.9 }}
          />
        </motion.div>
      </div>

      {modalData.isOpen && <LandingPageModal onClose={handleModalClose} type={modalData.type} />}
    </motion.section>
  )
}

export default Section2
